export const DIALOG_CONFIRM = "DIALOG_CONFIRM";
export const DIALOG_ADD_ACCOUNT = "DIALOG_ADD_ACCOUNT";
export const DIALOG_EDIT_ACCOUNT = "DIALOG_EDIT_ACCOUNT";
export const DIALOG_ADD_FEATURE_GROUP = "DIALOG_ADD_FEATURE_GROUP";
export const DIALOG_ADD_FEATURE_TYPE = "DIALOG_ADD_FEATURE_TYPE";
export const DIALOG_CREATE_LICENSE_TEMPLATE = "DIALOG_CREATE_LICENSE_TEMPLATE";
export const DIALOG_UPDATE_LICENSE_TEMPLATE = "DIALOG_UPDATE_LICENSE_TEMPLATE";
export const DIALOG_CREATE_LICENSE_LIMIT = "DIALOG_CREATE_LICENSE_LIMIT";
export const DIALOG_UPDATE_LICENSE_LIMIT = "DIALOG_UPDATE_LICENSE_LIMIT";
export const DIALOG_UPDATE_LICENSE_TEMPLATE_LIMIT =
  "DIALOG_UPDATE_LICENSE_TEMPLATE_LIMIT";
export const DIALOG_CREATE_PUSH_CENTER = "DIALOG_CREATE_PUSH_CENTER";
export const DIALOG_ADD_ROLE = "DIALOG_ADD_ROLE";
export const DIALOG_ADD_USER = "DIALOG_ADD_USER";
export const DIALOG_EDIT_USER = "DIALOG_EDIT_USER";
export const DIALOG_ADD_VERSION = "DIALOG_ADD_VERSION";
export const DIALOG_ADD_VERSION_LOCALE = "DIALOG_ADD_VERSION_LOCALE";
export const DIALOG_ADD_IU_VERSION = "DIALOG_ADD_IU_VERSION";
export const DIALOG_UPDATE_HMAC = "DIALOG_UPDATE_HMAC";
export const DIALOG_DELETE_HMAC = "DIALOG_DELETE_HMAC";
export const DIALOG_ASSIGN_FILES_TO_VERSION = "DIALOG_ASSIGN_FILES_TO_VERSION";
export const DIALOG_ABOUT = "DIALOG_ABOUT";
export const DIALOG_UPDATE_BILLING_URL = "DIALOG_UPDATE_BILLING_URL";
export const DIALOG_UPDATE_OKTA_SETTINGS = "DIALOG_UPDATE_OKTA_SETTINGS";
export const DIALOG_UPDATE_SMTP_SETTINGS = "DIALOG_UPDATE_SMTP_SETTINGS";
export const DIALOG_UPDATE_FTP_SETTINGS = "DIALOG_UPDATE_FTP_SETTINGS";
export const DIALOG_UPDATE_ACTION_LOG_SETTINGS =
  "DIALOG_UPDATE_ACTION_LOG_SETTINGS";
export const DIALOG_UPDATE_PATCH_TAG = "DIALOG_UPDATE_PATCH_TAG";
export const DIALOG_DELETE_PATCH_TAG = "DIALOG_DELETE_PATCH_TAG";
export const DIALOG_UPDATE_LICENSE_CERTIFICATE =
  "DIALOG_UPDATE_LICENSE_CERTIFICATE";
export const CREATE_ACCOUNT_NOTE = "CREATE_ACCOUNT_NOTE";
export const UPDATE_ACCOUNT_NOTE = "UPDATE_ACCOUNT_NOTE";
export const UPDATE_ACCOUNT_DEALER_INFO = "UPDATE_ACCOUNT_DEALER_INFO";
export const CREATE_ACCOUNT_APP_THEME = "CREATE_ACCOUNT_APP_THEME";
export const UPDATE_ACCOUNT_APP_THEME = "UPDATE_ACCOUNT_APP_THEME";
